import React, { useEffect, useRef, useState } from "react";
import { useCompetition } from "../../context/CompetitionContext";
import { useLanguage } from "../../context/LanguageContext";
import logo from "../../assets/images/godo_logo.svg";
import chevronDown from "../../assets/images/chevron-down.svg";

const Header = () => {
  const [open, setOpen] = useState(false);
  const { competition } = useCompetition();
  const { language, languages, setLanguage, t } = useLanguage();
  const langRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    const onPointerDown = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const onKeyDown = (event) => {
      if (event.key === "Escape") setOpen(false);
    };

    document.addEventListener("mousedown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("mousedown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  const selectLanguage = (next) => {
    setLanguage(next.locale);
    setOpen(false);
  };

  return (
    <header className="site-header">
      <div className="site-header__frame">
        <div className="site-header__inner">
          <a className="site-header__logo" href={`/${language.locale}`}>
            <img src={logo} alt={competition.brandName} />
          </a>

          <div className="site-header__lang-wrap" ref={langRef}>
            <button
              type="button"
              className={`site-header__lang${open ? " is-open" : ""}`}
              aria-label={t("header.selectLanguage")}
              aria-haspopup="listbox"
              aria-expanded={open}
              onClick={() => setOpen((value) => !value)}
            >
              <img
                className="site-header__lang-flag"
                src={language.flag}
                alt=""
                width={20}
                height={20}
              />
              <span className="site-header__lang-code">{language.code}</span>
              <img
                className="site-header__lang-chevron"
                src={chevronDown}
                alt=""
                width={24}
                height={24}
              />
            </button>

            {open ? (
              <ul className="site-header__lang-menu" role="listbox" aria-label={t("header.languages")}>
                {languages
                  .filter((item) => item.code !== language.code)
                  .map((item) => (
                    <li key={item.code} role="option" aria-selected="false">
                      <button
                        type="button"
                        className="site-header__lang-option"
                        onClick={() => selectLanguage(item)}
                      >
                        <img
                          className="site-header__lang-flag"
                          src={item.flag}
                          alt=""
                          width={20}
                          height={20}
                        />
                        <span className="site-header__lang-code">{item.code}</span>
                      </button>
                    </li>
                  ))}
              </ul>
            ) : null}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
